import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';
import { ArkikWebComponentsModule } from '../modules/arkik-web-components.module';
import { CoreLayoutComponent } from './layout.component';
import { CoreGlobalHeaderComponent } from './global-header/global-header.component';
import { CoreLayoutPipesModule } from './pipes/layout-pipes.module';
import { CORE_LAYOUT_TRANSLATION_SERVICE } from './tokens';
import { CoreLayoutNgxTranslationService } from './services/core-layout-ngx-translation.service';

@NgModule({
  declarations: [CoreLayoutComponent, CoreGlobalHeaderComponent],
  imports: [CommonModule, RouterModule, PortalModule, ArkikWebComponentsModule, CoreLayoutPipesModule],
  providers: [
    CoreLayoutNgxTranslationService,
    { provide: CORE_LAYOUT_TRANSLATION_SERVICE, useExisting: CoreLayoutNgxTranslationService },
  ],
  exports: [CoreLayoutComponent, CoreGlobalHeaderComponent, ArkikWebComponentsModule],
})
export class CoreLayoutModule {}
